module.exports = __webpack_public_path__ + "static/media/linkedin2.096ee485.png";